import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { Layout, theme } from 'antd'
import { LayoutSider } from './LayoutSider'
import { LayoutFooter } from './LayoutFooter'
import RightHeader from './RightHeader'
import EmailVerified from '../components/misc/EmailVerified'

const { Header, Content, Footer } = Layout

const LayoutGeneral: React.FC = () => {
  const navigate = useNavigate()

  const { token } = theme.useToken()

  const contentStyle: React.CSSProperties = {
    color: token.colorTextTertiary,
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ paddingLeft: 20, paddingRight: 20, background: '#fff' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            margin: 0,
            height: '100%',
            alignItems: 'center',
          }}
        >
          <img
            alt="My Easy Sign"
            src="/assets/logo_mes.png"
            style={{
              float: 'left',
              height: 46,
              cursor: 'pointer',
            }}
            onClick={() => navigate('/')}
          />
          <RightHeader />
        </div>
      </Header>
      <Layout>
        <LayoutSider />
        <Layout style={{ padding: '0 24px 24px', background: '#f8f8f2' }}>
          <Content style={contentStyle}>
            <EmailVerified />
            <Outlet />
          </Content>
          <LayoutFooter />
        </Layout>
      </Layout>
    </Layout>
  )
}

export default LayoutGeneral
